<template>
  <mds-section
    :class="$style['annuity-dialog-custom-input']"
    border="tertiary"
    :size="7"
    :title="title"
  >
    <template v-slot:mds-section-actions>
      <mds-switch v-model="include" :class="$style['include-switch']">
        {{ translate('include') }}
      </mds-switch>
    </template>
    <template v-if="include">
      <mds-layout-grid :class="$style['custom-input-content']">
        <mds-row>
          <mds-col :cols="withCredit ? 6 : 4">
            <mds-form>
              <mds-input
                :value="name"
                :label="translate('name')"
                size="small"
                :placeholder="translate('riderName')"
                maxlength="50"
                @blur="name = $event.target.value"
              ></mds-input
            ></mds-form>
          </mds-col>
          <mds-col v-if="!withCredit" :cols="2">
            <mds-form>
              <hypo-number-input
                :label="translate('benefitFee')"
                :hidden-label="false"
                :saved-value="fee"
                is-percent
                size="small"
                :fraction-digits="formatter.number.maximumFractionDigits || 2"
                :allow-negative="false"
                @update-saved-value="fee = $event"
              >
              </hypo-number-input>
            </mds-form>
          </mds-col>
        </mds-row>
        <mds-row v-if="withCredit">
          <mds-col :cols="3">
            <mds-form>
              <hypo-number-input
                :label="translate('benefitFee')"
                :hidden-label="false"
                :saved-value="fee"
                is-percent
                size="small"
                :fraction-digits="formatter.number.maximumFractionDigits || 2"
                :allow-negative="false"
                @update-saved-value="fee = $event"
              >
              </hypo-number-input
            ></mds-form>
          </mds-col>
          <mds-col :cols="3">
            <mds-form>
              <hypo-number-input
                :label="translate('benefitCredit')"
                :hidden-label="false"
                :saved-value="credit"
                is-percent
                size="small"
                :fraction-digits="formatter.number.maximumFractionDigits || 2"
                :allow-negative="false"
                @update-saved-value="credit = $event"
              >
              </hypo-number-input
            ></mds-form>
          </mds-col>
        </mds-row>
        <mds-row>
          <mds-col :cols="6">
            <mds-form>
              <mds-textarea
                :value="description"
                :label="translate('description')"
                size="small"
                :placeholder="translate('enterADescription')"
                maxlength="300"
                @blur="description = $event.target.value"
              >
              </mds-textarea>
            </mds-form>
          </mds-col>
        </mds-row>
      </mds-layout-grid>
    </template>
  </mds-section>
</template>

<script>
import MwcVueHelperMixin, { MwcConfigMixin } from 'mwc-vue-component-helper';
import MdsSection from '@mds/section';
import MdsSwitch from '@mds/switch';
import { MdsLayoutGrid, MdsRow, MdsCol } from '@mds/layout-grid';
import MdsForm from '@mds/form';
import MdsInput from '@mds/input';
import MdsTextarea from '@mds/textarea';
import HypoNumberInput from 'hypo-shared-utils/src/components/HypoNumberInput';
import isEqual from 'lodash.isequal';

export default {
  name: 'annuity-dialog-custom-input',
  components: {
    MdsSection,
    MdsSwitch,
    MdsLayoutGrid,
    MdsRow,
    MdsCol,
    MdsForm,
    MdsInput,
    MdsTextarea,
    HypoNumberInput,
  },
  mixins: [MwcVueHelperMixin, MwcConfigMixin],
  props: {
    title: {
      type: String,
      default: 'Input',
    },
    withCredit: {
      type: Boolean,
      default: false,
    },
    savedData: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      include: false,
      name: null,
      fee: 0,
      credit: 0,
      description: null,
    };
  },
  computed: {
    dataMonitored() {
      const data = {
        include: this.include,
        name: this.name,
        fee: this.fee,
        description: this.description,
      };
      if (this.withCredit) {
        data.credit = this.credit;
      }
      return data;
    },
  },
  watch: {
    dataMonitored: {
      handler(newVal, oldVal) {
        if (!isEqual(newVal, oldVal)) {
          this.$emit('input-changed', this.dataMonitored);
        }
      },
    },
    savedData: {
      handler() {
        this.syncPropSavedData();
      },
    },
  },
  created() {
    this.syncPropSavedData();
  },
  methods: {
    syncPropSavedData() {
      const { include, name, fee, description, credit } = this.savedData;
      this.include = include;
      this.name = name;
      this.fee = fee;
      this.description = description;
      this.credit = credit;
    },
  },
};
</script>

<style lang="scss" module>
@import '@mds/typography';
.annuity-dialog-custom-input {
  .mds-section__actions {
    margin-right: $mds-space-2-and-a-half-x;
  }

  .include-switch {
    margin-right: $mds-space-three-quarter-x;
  }

  .custom-input-content {
    margin-bottom: $mds-space-2-x;
    .mds-form {
      margin-bottom: $mds-space-1-and-a-half-x;
    }
  }
}
</style>
